import { Grid } from '@mui/material';
import useAuthorization from 'FeatureModules/Auth/hooks/useAuthorization';
import usePageTitle from 'hooks/usePageTitle';
import useUserData from 'FeatureModules/Auth/hooks/useUserData';
import { useCompanyPlanContext } from 'FeatureModules/Auth/Contexts/CompanyPlanContext';
import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { ECustomerPlan } from 'FeatureModules/Auth/types/company.types';
import SettingsSidebar from '../Components/SettingsSidebar';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';

const SettingsLayout: FC = () => {
  usePageTitle('Settings');
  const { isAdmin } = useAuthorization();
  const { company } = useUserData();
  const { plan } = useCompanyPlanContext();
  const isFreemium = plan === ECustomerPlan.FREEMIUM;

  const menu = [
    {
      label: 'Profile',
      to: '/settings',
      active: true,
    },
    {
      label: 'Security',
      to: '/settings/security',
      active: true,
    },
    {
      label: 'Notifications',
      to: '/settings/notifications',
      active: !isFreemium,
    },
    {
      label: 'Company',
      to: '/settings/company',
      displayWarning: company && !company.dataValid,
      active: isAdmin,
    },
    {
      label: 'Data formats',
      to: '/settings/data-format',
      active: true,
    },
    {
      label: 'Users',
      to: '/settings/users',
      active: isAdmin,
    },
    {
      label: 'Integrations',
      to: '/settings/integrations',
      active: !isFreemium && isAdmin,
    },
    {
      label: 'Branding',
      to: '/settings/branding',
      active: !isFreemium && isAdmin,
    },
    {
      label: 'Google Analytics',
      to: '/settings/google-analytics',
      active: isAdmin && plan === ECustomerPlan.PAYING,
    },
  ];

  return (
    <PageContainer>
      <PageTitle title="Settings" />
      <Grid container direction="row" mt={2} spacing={2}>
        <Grid item xs={2}>
          <SettingsSidebar menu={menu} />
        </Grid>
        <Grid item xs={10}>
          <Outlet />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default SettingsLayout;
